module.exports = __webpack_public_path__ + "static/media/OMINT.d1e4f87b.png";